import { useState } from 'react';
import { useDeepCompareEffect } from 'react-use';

import { ReceptionServiceWithPractitionersSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { Anchor, AnchorAlignment, Notification, NotificationType, StyledFlex } from '@dreryk/react-components';
import { createInterpolatedTranslationKey } from '@dreryk/react-common';

import { isEmpty } from '~libs.typescript';

import { translationKeys } from '../../../translations';

import { GroupSessionsPractitionerValue } from './GroupSessionsPractitionersField.types';

type GroupSessionsReceptionServiceNoificationProps = {
   selectedPractitioners: GroupSessionsPractitionerValue[];
   selectedReceptionService: ReceptionServiceWithPractitionersSimple | null | undefined;
};

export const GroupSessionsReceptionServiceNoification = (
   props: GroupSessionsReceptionServiceNoificationProps
): JSX.Element | null => {
   const [practitionersNotAssignedToReceptionService, setPractitionersNotAssignedToReceptionService] = useState<
      GroupSessionsPractitionerValue[]
   >([]);

   useDeepCompareEffect(() => {
      if (isEmpty(props.selectedPractitioners) || isEmpty(props.selectedReceptionService)) {
         return setPractitionersNotAssignedToReceptionService([]);
      }

      const receptionServicePractitionersSet = new Set(
         props.selectedReceptionService.practitioners.map(({ practitioner }) => practitioner.id)
      );

      return setPractitionersNotAssignedToReceptionService(
         props.selectedPractitioners.filter(
            (practitioner) => !receptionServicePractitionersSet.has(practitioner.id.asNumber())
         )
      );
   }, [props.selectedReceptionService, props.selectedPractitioners]);

   if (isEmpty(practitionersNotAssignedToReceptionService)) {
      return null;
   }

   return (
      <Anchor shouldPerformScroll verticalAlignment={AnchorAlignment.END} testId={'serviceLocationWarning'}>
         <StyledFlex direction={'column'} gap={'4px'}>
            {practitionersNotAssignedToReceptionService.map((practitioner) => (
               <Notification
                  key={practitioner.id.asNumber()}
                  testId={'serviceLocationWarning'}
                  type={NotificationType.WARNING}
                  label={createInterpolatedTranslationKey(translationKeys.practitionerHasNoAssignedReceptionService, {
                     practitionerName: practitioner.displayName,
                  })}
               />
            ))}
         </StyledFlex>
      </Anchor>
   );
};
